module.exports = __webpack_public_path__ + "img/huawei.58c83e23.png";